var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"chartCanvas",style:(_vm.chartStyle ? _vm.chartStyle : { width: '100%', height: '180px' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }